import { toast } from "react-toastify";
import { axiosUnauthInstance } from "../../service/API";
import { loadCountries } from "../slice/findJobSlice";
import { setDeveloperDetail, setDeveloperLoading, setSpecializationList, setSpecializationLoading } from "../slice/commonSlice";
import { setTechnologies, setTechnologyLoading } from "../slice/commonSlice";

export const handleUploadFile = (payload) => {
    return async (dispatch) => {
        try {
            const { status, data } = await axiosUnauthInstance.post('/upload-file/', payload);
            if (status === 201) toast.success(data?.message);
            return { status, data };
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }
}

export const fetchCountries = () => {
    return async (dispatch) => {
        try {
            const { status, data } = await axiosUnauthInstance.get('/countries/');
            if (status === 200) dispatch(loadCountries(data));
            return { status, data };
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }
}

export const fetchDeveloperDetail = (slug) => {
    return async (dispatch) => {
        try {
            const { status, data } = await axiosUnauthInstance.get(`/developer/${slug}/`);
            if (status === 200) {
                dispatch(setDeveloperDetail(data))
                dispatch(setDeveloperLoading(false))
            }
            return status;
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }
}

export const fetchSpecialization = () => {
    return async (dispatch) => {
        try {
            const { status, data } = await axiosUnauthInstance.get('/specializations/');
            if (status === 200) {
                dispatch(setSpecializationList(data))
                dispatch(setSpecializationLoading(false))
            }
            return { status, data };
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }
}

export const fetchSkills = (pageSize = 60, searchQuery = '') => {
    return async (dispatch) => {
        try {
            const { status, data } = await axiosUnauthInstance.get(`/skills/?page_size=${pageSize}&search=${searchQuery}`);
            if (status === 200) {
                dispatch(setTechnologies(data.results))
                dispatch(setTechnologyLoading(false))
            }
            return { status, data };
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }
}